export default __webpack_public_path__ + "static/media/suggested-vat-5-5.61e37c40.png";